// Copyright 2020 Prescryptive Health, Inc.

import { BusyDispatch } from './busy.dispatch';
import { busyPopAction } from '../actions/busy-pop.action';

export const busyPopDispatch = (dispatch: BusyDispatch): void => {
  dispatch(busyPopAction());
};
